import { Provider as JotaiProvider } from 'jotai';
import { useEffect, useState } from 'react';
import { Switch, useLocation } from 'react-router-dom';

import FlowRoute from '../components/routeComponents/FlowRoute';
import LERoute from '../components/routeComponents/LERoute';
import {
  AFFILIATE_ENTRY,
  ALL_DONE,
  COBUYER_LOAN_APPLICATION,
  FLOW_REENTER,
  GETTING_STARTED,
  LOAN_APPLICATION,
  NEXT_STEPS,
  PAYOFF_INSTRUCTIONS,
  SELL_DETAILS,
  TEMP_INFO_PAGES,
} from '../constants/urls';
import { useTemporaryInfoUpdateMutation } from '../gql/generated/graphql';
import { useTempInfo } from '../hooks';
import { CookieKeys, useCookie } from '../hooks/useCookie';
import PageFor404s from '../pages/404Page';
import CobuyerLoanApp from '../pages/CobuyerLoanApp';
import GettingStarted from '../pages/GettingStarted';
import LoanApp from '../pages/LoanApp';
import PayoffInstructions from '../pages/PayoffInstructions';
import SellDetails from '../pages/SellDetails';
import AllDone from '../pages/allDone/AllDone';
import AffiliateEntry from '../pages/flowEntryPages/AffiliateEntry';
import FlowReenter from '../pages/flowEntryPages/FlowReenter';
import NextSteps from '../pages/nextSteps/NextSteps';

const FlowRoutes = () => {
  const { pathname } = useLocation();
  const { info } = useTempInfo({ fetchPolicy: 'network-only', refresh: true });

  const [guid] = useCookie<string>(CookieKeys.GUID_KEY);
  const [updateTempInfo] = useTemporaryInfoUpdateMutation({
    context: {
      isErrorHandled: true, // Avoid showing error if we can't update the temp info
    },
  });
  const [prevPathname, setPrevPathname] = useState('');

  useEffect(() => {
    if (pathname === prevPathname) {
      return;
    }
    setPrevPathname(pathname);

    if (TEMP_INFO_PAGES.includes(pathname) && !!guid) {
      const hasHitPrequalification = info?.data?.prequalification_success != null;
      updateTempInfo({
        variables: {
          info: {
            id: guid,
            data: {
              last_url: hasHitPrequalification ? NEXT_STEPS : pathname,
            },
          },
        },
      });
    }
  }, [pathname, guid]);

  return (
    <Switch>
      <FlowRoute path={GETTING_STARTED} component={GettingStarted} title="Getting Started" />
      <FlowRoute
        path={COBUYER_LOAN_APPLICATION}
        component={CobuyerLoanApp}
        title="Co-Buyer Loan Application"
      />
      <FlowRoute path={SELL_DETAILS} component={SellDetails} title="Sell Your Car" />
      <FlowRoute path={LOAN_APPLICATION} component={LoanApp} title="Loan Application" />
      <FlowRoute path={PAYOFF_INSTRUCTIONS} title="Payoff Instructions">
        <JotaiProvider key="payoffInstructions">
          <PayoffInstructions />
        </JotaiProvider>
      </FlowRoute>
      <FlowRoute path={NEXT_STEPS} component={NextSteps} title="Next Steps" />
      <LERoute path={ALL_DONE} component={AllDone} title="All Done" />
      <LERoute path={FLOW_REENTER} component={FlowReenter} title="Flow | Lease End" exact />
      <LERoute path={AFFILIATE_ENTRY} component={AffiliateEntry} title="Flow | Lease End" exact />
      <LERoute path="*" component={PageFor404s} title="LeaseEnd - 404" />
    </Switch>
  );
};

export default FlowRoutes;
